import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('EstatePlanningProfileSubpageImage', (theme) => ({
  img: {
    objectFit: 'cover',
    borderRadius: theme.spacing(2),
    width: '100%',
    minWidth: 0,
    flexGrow: 1,
  },
}));

const EstatePlanningProfileSubpageImage = ({
  imageURL,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <img src={imageURL} className={classes.img} alt={'Estate Planning'} />
  );
};

EstatePlanningProfileSubpageImage.propTypes = {
  imageURL: PropTypes.string.isRequired,
};

export default EstatePlanningProfileSubpageImage;
